/* eslint-disable */
import axios from 'axios';
import dotenv from 'dotenv';
import jwt from 'jsonwebtoken';
import router from './../router';
import { STATUS_CODE } from '@/utils/commun/statusCode';
dotenv.config();
var apiIP = '';
if (process.env.VUE_APP_IP_API) {
  apiIP = `${process.env.VUE_APP_IP_API}`;
  if (process.env.VUE_APP_PORT_REST)
    apiIP = apiIP + `:${process.env.VUE_APP_PORT_REST}`;
} else {
  apiIP = 'https://api2.bbonebrasil.com.br';
}

const dominio = window.location.href.toString();
const isStaging = dominio.indexOf('staging.') >= 0;
const isQa = dominio.indexOf('qa.') >= 0;

if (isQa) {
  apiIP = 'https://qa.bbonebrasil.com.br';
}

if (isStaging) {
  apiIP = 'https://staging.bbonebrasil.com.br';
}

const constructEndpoint = (controllerName, action, extraParams) => {
  const baseEndpoint = `${apiIP}/${controllerName}/${action}?`
    .replace('idEmpresa=null', getIdEmpresa())
    .replace('idEmpresa=undefined', getIdEmpresa())
    .replace('idUsuario=null', getIdUser());

  const paginationParams = `page=${extraParams.page}&limit=${extraParams.limit}`;

  // Removing page and limit from extraParams to avoid duplication
  delete extraParams.page;
  delete extraParams.limit;

  if (extraParams.filter) {
    const filterParams = `filter=${extraParams.filter}`;
    return `${baseEndpoint}${filterParams}&${paginationParams}`;
  }
  return `${baseEndpoint}${paginationParams}`;
};

const ACTION_DEFAULT = 'list';
const ERROR_MESSAGE_DEFAULT = 'Ação não Encontrada';
const TIMEOUT_FIVE_MINUTES_IN_MS = 300000;

const getIdEmpresa = () => {
  const decoded = jwt.decode(localStorage.getItem('user-token'));
  if (decoded) {
    return decoded.id_empresa;
  }
  return null;
};

const getIdUser = () => {
  const decoded = jwt.decode(localStorage.getItem('user-token'));
  if (decoded) {
    return decoded.id_usuario;
  }
  return null;
};

const redirectLogIn = (statusCode) => {
  if (statusCode === STATUS_CODE.UNAUTHORIZED) {
    router.push('/Login');
    return true;
  }
  return false;
};

export default {
  getAll(controllerName, extraParams, action = 'list') {
    return new Promise((resolve, reject) => {
      try {
        var endpoint = `${apiIP}/${controllerName}/${action}`;
        if (extraParams)
          if (extraParams.PageNumber != undefined) {
            if (action == '') {
              endpoint = endpoint + 'Page/' + extraParams.PageNumber;
            } else {
              endpoint = endpoint + '/' + extraParams.PageNumber;
            }
          }
        endpoint = endpoint
          .replace('idEmpresa=null', getIdEmpresa())
          .replace('idEmpresa=undefined', getIdEmpresa())
          .replace('idUsuario=null', getIdUser());

        var token = localStorage.getItem('user-token');
        axios
          .get(endpoint, {
            timeout: TIMEOUT_FIVE_MINUTES_IN_MS,
            headers: {
              Authorization: token,
              'Access-Control-Allow-Origin': '*',
            },
          })
          .then(function (response) {
            resolve(response);
          })
          .catch(function (error) {
            if (error.response) {
              redirectLogIn(error.response.status);

              if (error.response.data.error) {
                reject(error.response.data.error.errorMessage);
              } else {
                reject('Ação não Encontrada');
              }
            } else {
              // antigo Erro Sistemico
              reject('Falha na conexão com internet, tente novamente');
            }
          });
      } catch (e) {
        reject(e);
      }
    });
  },

  async get(controllerName, extraParams) {
    try {
      const endpoint = extraParams
        ? `${apiIP}/${controllerName}/${extraParams}`
        : `${apiIP}/${controllerName}`;
      const hasTimeout = extraParams && extraParams.timeout;
      const timeout = hasTimeout
        ? extraParams.timeout
        : TIMEOUT_FIVE_MINUTES_IN_MS;
      const token = localStorage.getItem('user-token');
      const { data } = await axios.get(endpoint, {
        timeout: timeout,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
        },
      });
      return data;
    } catch (error) {
      redirectLogIn(error.response.status);

      if (error.response && error.response.data.error) {
        throw new Error(error.response.data.error.errorMessage);
      }

      throw new Error(ERROR_MESSAGE_DEFAULT);
    }
  },

  getDocumentBlob(controllerName, extraParams) {
    return new Promise((resolve, reject) => {
      try {
        const endpoint = `${apiIP}/${controllerName}`;
        const hasTimeout = extraParams && extraParams.timeout;
        const timeout = hasTimeout
          ? extraParams.timeout
          : TIMEOUT_FIVE_MINUTES_IN_MS;
        const token = localStorage.getItem('user-token');
        axios
          .get(endpoint, {
            timeout: timeout,
            headers: {
              Authorization: token,
            },
            responseType: 'blob',
            params: {
              ...extraParams,
            },
          })
          .then(function (response) {
            resolve(response);
          })
          .catch(function (error) {
            redirectLogIn(error.response.status);

            reject(error);
          });
      } catch (e) {
        reject(e);
      }
    });
  },

  postDocumentBlob(controllerName, body) {
    return new Promise((resolve, reject) => {
      try {
        const endpoint = `${apiIP}/${controllerName}`;
        const token = localStorage.getItem('user-token');
        axios
          .post(endpoint, body, {
            timeout: TIMEOUT_FIVE_MINUTES_IN_MS,
            headers: {
              Authorization: token,
            },
            responseType: 'blob',
          })
          .then(function (response) {
            resolve(response);
          })
          .catch(function (error) {
            redirectLogIn(error.response.status);

            reject(error);
          });
      } catch (e) {
        reject(e);
      }
    });
  },

  async getFilterPagination(
    controllerName,
    extraParams,
    action = ACTION_DEFAULT,
  ) {
    try {
      const endpoint = constructEndpoint(controllerName, action, extraParams);
      const token = localStorage.getItem('user-token');
      const { data } = await axios.get(endpoint, {
        timeout: TIMEOUT_FIVE_MINUTES_IN_MS,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
        },
        params: {
          ...extraParams,
        },
      });
      return data;
    } catch (error) {
      redirectLogIn(error.response.status);

      if (error.response && error.response.data.error) {
        throw new Error(error.response.data.error.errorMessage);
      }
      throw new Error(ERROR_MESSAGE_DEFAULT);
    }
  },

  getFilter(controllerName, extraParams) {
    return new Promise((resolve, reject) => {
      try {
        const endpoint = `${apiIP}/${controllerName}/filter/${extraParams.SearchText}?page=${extraParams.PageNumber}`;

        axios
          .get(endpoint, {
            extraParams,
          })
          .then(function (response) {
            resolve(response);
          })
          .catch(function (error) {
            redirectLogIn(error.response.status);

            if (error.response.data.error) {
              reject(error.response.data.error.errorMessage);
            } else {
              reject('Ação não Encontrada');
            }
          });
      } catch (e) {
        reject(e);
      }
    });
  },
  async patch(controllerName, body, extraParams) {
    try {
      const companyId = await getIdEmpresa();
      const endpoint = `${apiIP}/${controllerName}/${companyId}`;
      const token = localStorage.getItem('user-token');
      const hasTimeout = extraParams && extraParams.timeout;
      const timeout = hasTimeout ? extraParams.timeout : 3000;
      const { data } = await axios.patch(endpoint, body, {
        timeout,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
        },
      });

      return data;
    } catch (err) {
      const { response } = err;
      const { data } = response;
      redirectLogIn(error.response.status);

      throw data.message;
    }
  },
  async patchWithoutCompanyId(controllerName, body, extraParams) {
    try {
      const endpoint = `${apiIP}/${controllerName}`;
      const token = localStorage.getItem('user-token');
      const hasTimeout = extraParams && extraParams.timeout;
      const timeout = hasTimeout ? extraParams.timeout : 3000;
      const { data } = await axios.patch(endpoint, body, {
        timeout,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
        },
      });

      return data;
    } catch (err) {
      const { response } = err;
      const { data } = response;

      redirectLogIn(error.response.status);

      throw data.message;
    }
  },
  async postAsync(controllerName, action = 'create', data, extraParams) {
    const payloadData = data;
    try {
      let endpoint = `${apiIP}/${controllerName}/${action}`;

      const idEmpresa = await getIdEmpresa();

      const payload = { ...payloadData, idEmpresa: idEmpresa };

      const token = localStorage.getItem('user-token');
      const hasTimeout = extraParams && extraParams.timeout;
      const timeout = hasTimeout
        ? extraParams.timeout
        : TIMEOUT_FIVE_MINUTES_IN_MS;
      const { data } = await axios.post(endpoint, payload, {
        timeout: timeout,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
        },
      });
      return data;
    } catch (err) {
      redirectLogIn(error.response.status);

      throw err.response.data.message;
    }
  },

  post(controllerName, action = 'create', data, extraParams) {
    return new Promise((resolve, reject) => {
      try {
        var endpoint = `${apiIP}/${controllerName}/${action}`;
        if (extraParams)
          if (extraParams.PageNumber != undefined) {
            if (action == '') {
              endpoint = endpoint + 'Page/' + extraParams.PageNumber;
            } else {
              endpoint = endpoint + '/' + extraParams.PageNumber;
            }
          }

        if (!data.idEmpresa && data.idEmpresa != 0)
          data.idEmpresa = getIdEmpresa();

        var token = localStorage.getItem('user-token');

        const hasTimeout = extraParams && extraParams.timeout;
        const timeout = hasTimeout
          ? extraParams.timeout
          : TIMEOUT_FIVE_MINUTES_IN_MS;
        const hasApikey = extraParams && extraParams.xApiKey;

        const apikey = process.env.VUE_APP_SECRET_X_API_KEY;
        const hasXApiKeyTimestamp = extraParams && extraParams.xApiKeyTimestamp;
        const xApiKeyTimestamp = hasXApiKeyTimestamp
          ? extraParams.xApiKeyTimestamp
          : null;

        const configureheader = {
          timeout: timeout,
          headers: {
            Authorization: token,
            'Access-Control-Allow-Origin': '*',
            'x-api-key': apikey,
            'x-api-key-timestamp': xApiKeyTimestamp,
          },
        };

        axios
          .post(endpoint, data, configureheader)
          .then(function (response) {
            resolve(response);
          })
          .catch(function (error) {
            if (error.response) {
              redirectLogIn(error.response.status);

              const messageData =
                typeof error.response.data === 'string'
                  ? error.response.data
                  : 'Ação não Encontrada';
              const message = error.response.data.hasOwnProperty('error')
                ? error.response.data.error.errorMessage
                : messageData;

              if (extraParams && extraParams.preserveErrorStatus) {
                reject({
                  message,
                  statusCode: error.response.status,
                });
                return;
              }

              reject(message);
            } else {
              reject('Falha na conexão com internet, tente novamente');
            }
          });
      } catch (e) {
        reject(e);
      }
    });
  },

  login(controllerName, action = 'login', data) {
    return new Promise((resolve, reject) => {
      try {
        var endpoint = `${apiIP}/${controllerName}/${action}`;
        var basicAuth = 'Basic ' + btoa(JSON.stringify(data));
        axios
          .post(
            endpoint,
            {},
            {
              timeout: TIMEOUT_FIVE_MINUTES_IN_MS,
              headers: {
                Authorization: basicAuth,
                'Access-Control-Allow-Origin': '*',
              },
            },
          )
          .then(function (response) {
            resolve(response);
          })
          .catch(function (error) {
            redirectLogIn(error.response.status);

            if (error && error.response)
              if (error.response.data) {
                if (error.response.data.error) {
                  if (error.response.data.error.errorMessage)
                    reject(error.response.data.error.errorMessage);
                  else reject();
                } else {
                  reject(error);
                }
              }
            if (error) {
              reject();
            }
          });
      } catch (e) {
        reject(e);
      }
    });
  },

  upload(controllerName, action, data, extraParams) {
    return new Promise((resolve, reject) => {
      try {
        action = action
          .replace('idEmpresa=null', getIdEmpresa())
          .replace('idUsuario=null', getIdUser());

        const token = localStorage.getItem('user-token');

        var endpoint = `${apiIP}/${controllerName}/${action}`;

        const headers = {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'multipart/form-data',
        };

        if (token) {
          headers['Authorization'] = token;
        }

        axios
          .post(endpoint, data, {
            timeout: TIMEOUT_FIVE_MINUTES_IN_MS,
            headers,
          })
          .then(function (response) {
            resolve(response.data);
          })
          .catch(function (error) {
            redirectLogIn(error.response.status);

            if (error.response.data.error) {
              reject(error.response.data.error.errorMessage);
            } else {
              reject('Ação não Encontrada');
            }
          });
      } catch (e) {
        reject(e);
      }
    });
  },
  uploadAll(controllerName, action, files) {
    return new Promise((resolve, reject) => {
      try {
        action = action.replace('idEmpresa=null', getIdEmpresa());

        const token = localStorage.getItem('user-token');
        const endpoint = `${apiIP}/${controllerName}/${action}`;
        const headers = {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'multipart/form-data',
        };

        if (token) {
          headers['Authorization'] = token;
        }

        axios
          .post(endpoint, files, {
            timeout: TIMEOUT_FIVE_MINUTES_IN_MS,
            headers,
          })
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            if (error.response) {
              redirectLogIn(error.response.status);
              if (error.response.data && error.response.data.error) {
                reject(
                  error.response.data.error.errorMessage ||
                    'Erro ao fazer upload dos arquivos.',
                );
              } else {
                reject('Erro ao fazer upload dos arquivos.');
              }
            } else {
              reject('Falha no upload dos arquivos, tente novamente.');
            }
          });
      } catch (e) {
        reject(e);
      }
    });
  },

  put(controllerName, action = 'update', data, extraParams) {
    return new Promise((resolve, reject) => {
      try {
        var endpoint = `${apiIP}/${controllerName}/${action}`;
        data.idEmpresa = getIdEmpresa();
        var token = localStorage.getItem('user-token');

        axios
          .put(endpoint, data, {
            timeout: TIMEOUT_FIVE_MINUTES_IN_MS,
            headers: {
              Authorization: token,
              'Access-Control-Allow-Origin': '*',
            },
          })
          .then(function (response) {
            resolve(response);
          })
          .catch(function (error) {
            redirectLogIn(error.response.status);

            if (error.response) {
              redirectLogIn(error.response.status);

              if (error.response.data.error) {
                reject(error.response.data.error);
              } else {
                reject('Ação não Encontrada');
              }
            } else {
              // antigo Erro Sistemico
              reject('Falha na conexão com internet, tente novamente');
            }
          });
      } catch (e) {
        reject(e);
      }
    });
  },

  delete(controllerName, action = 'update', data = {}, extraParams = {}) {
    return new Promise((resolve, reject) => {
      try {
        var endpoint = `${apiIP}/${controllerName}/${action}`;
        var token = localStorage.getItem('user-token');
        const timeout =
          extraParams && extraParams.timeout
            ? extraParams.timeout
            : TIMEOUT_FIVE_MINUTES_IN_MS;

        const config = {
          timeout,
          headers: {
            Authorization: token,
            'Access-Control-Allow-Origin': '*',
          },
          ...(data && Object.keys(data).length && { data }),
        };
        axios
          .delete(endpoint, config)
          .then(function (response) {
            resolve(response);
          })
          .catch(function (error) {
            redirectLogIn(error.response.status);

            if (error.response.data.error) {
              reject(error.response.data.error.errorMessage);
            } else {
              reject('Ação não Encontrada');
            }
          });
      } catch (e) {
        reject(e);
      }
    });
  },

  validaToken(token, controllerName, action) {
    return new Promise((resolve, reject) => {
      try {
        var endpoint = `${apiIP}/${controllerName}/${action}`;
        axios
          .post(
            endpoint,
            {
              front: true,
            },
            {
              headers: {
                timeout: TIMEOUT_FIVE_MINUTES_IN_MS,
                Authorization: token,
                'Access-Control-Allow-Origin': '*',
              },
            },
          )
          .then(function (response) {
            resolve(response);
          })
          .catch(function (error) {
            redirectLogIn(error.response.status);

            resolve({
              data: {
                result: false,
              },
            });
          });
      } catch (e) {
        reject(e);
      }
    });
  },

  async getBlob(controllerName, extraParams = {}) {
    try {
      const endpoint = `${apiIP}/${controllerName}/${extraParams.path || ''}`;
      const timeout = extraParams.timeout || TIMEOUT_FIVE_MINUTES_IN_MS;
      const token = localStorage.getItem('user-token');

      const method = extraParams.method || 'GET';
      const data = extraParams.data || null;

      const responseType = extraParams.responseType || 'json';

      const config = {
        timeout,
        responseType,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
        },
      };

      const response =
        method === 'POST'
          ? await axios.post(endpoint, data, config)
          : await axios.get(endpoint, config);

      return response.data;
    } catch (error) {
      redirectLogIn(error.response.status);

      if (error.response && error.response.data.error) {
        throw new Error(error.response.data.error.errorMessage);
      }

      throw new Error(ERROR_MESSAGE_DEFAULT);
    }
  },

  /**
   * Verifica o valor da variável de ambiente VUE_APP_MAINTENANCE, caso possua
   * redireciona para a tela de Manutenção, caso contrario para a tela de Login
   * @param {Object} object this.$router
   */
  maintenance(next) {
    const maintenance = process.env.VUE_APP_MAINTENANCE;
    if (maintenance) {
      return next.push('/maintenance');
    }
  },
};
